import { all, call, put, take } from 'redux-saga/effects';

import {
  fetchEntity,
  postOrder,
  fetchEntityDocuments,
  fetchEntityProducts,
  fetchEntityInstruments,
  fetchArtifacts,
  requestCreditReviewRatings,
} from 'services';

import { getCreditReviewContractDataAction } from 'store/creditReview/creditReviewActions';
import { creditReviewRequestTooltips } from 'shared/constants/creditReview/creditReviewRequestTooltips';
import { cofaceAccessTypes } from 'shared/constants/creditReview/cofaceAccessTypes';
import {
  GET_ENTITY_SUCCESS,
  GET_ENTITY_ERROR,
  GET_ENTITY_DOCUMENTS_SUCCESS,
  GET_ENTITY_DOCUMENTS_ERROR,
  GET_ENTITY_PRODUCTS_SUCCESS,
  GET_ENTITY_PRODUCTS_ERROR,
  GET_ENTITY_INSTRUMENTS_SUCCESS,
  GET_ENTITY_INSTRUMENTS_ERROR,
  GET_ENTITY_RATING_NEWS_SUCCESS,
  GET_ENTITY_RATING_NEWS_ERROR,
  GET_ENTITY_RESEARCH_SUCCESS,
  GET_ENTITY_RESEARCH_ERROR,
  REQUEST_ENTITY_RATING_SUCCESS,
  REQUEST_ENTITY_RATING_ERROR,
  REQUEST_ENTITY_RATING_AND_FETCH_DATA_SUCCESS,
  REQUEST_ENTITY_RATING_AND_FETCH_DATA_ERROR,
  requestEntityRatingAction,
  getEntityDocumentsAction,
  getEntityProductsAction,
  REQUEST_SIG_ENTITY_RATING_SUCCESS,
  REQUEST_SIG_ENTITY_RATING_ERROR,
  requestConfirmationChangedAction,
} from './entityActions';

import { addNotificationAction } from '../notifications/notificationsActions';

export function* fetchEntitySaga({ payload }) {
  try {
    const response = yield call(fetchEntity, payload);
    yield put({ type: GET_ENTITY_SUCCESS, payload: response });
  } catch (response) {
    yield put({ type: GET_ENTITY_ERROR, payload: response });
  }
}

export function* fetchEntityDocumentsSaga({ payload }) {
  try {
    const response = yield call(fetchEntityDocuments, payload);
    yield put({ type: GET_ENTITY_DOCUMENTS_SUCCESS, payload: response });
  } catch (response) {
    yield put({ type: GET_ENTITY_DOCUMENTS_ERROR, payload: response });
  }
}

export function* fetchEntityProductsSaga({ payload }) {
  try {
    const response = yield call(fetchEntityProducts, payload);
    yield put({ type: GET_ENTITY_PRODUCTS_SUCCESS, payload: response });
  } catch (response) {
    yield put({ type: GET_ENTITY_PRODUCTS_ERROR, payload: response });
  }
}

export function* fetchEntityInstrumentsSaga({ payload }) {
  try {
    const response = yield call(fetchEntityInstruments, payload);
    yield put({ type: GET_ENTITY_INSTRUMENTS_SUCCESS, payload: response });
  } catch (response) {
    yield put({ type: GET_ENTITY_INSTRUMENTS_ERROR, payload: response });
  }
}

export function* fetchEntityRatingNewsSaga({ payload }) {
  try {
    const response = yield call(fetchArtifacts, payload);
    yield put({ type: GET_ENTITY_RATING_NEWS_SUCCESS, payload: response });
  } catch (response) {
    yield put({ type: GET_ENTITY_RATING_NEWS_ERROR, payload: response });
  }
}

export function* fetchEntityResearchSaga({ payload }) {
  try {
    const response = yield call(fetchArtifacts, payload);
    yield put({ type: GET_ENTITY_RESEARCH_SUCCESS, payload: response });
  } catch (response) {
    yield put({ type: GET_ENTITY_RESEARCH_ERROR, payload: response });
  }
}

export function* requestEntityRatingSaga({ payload }) {
  try {
    yield call(postOrder, payload);
    yield put({ type: REQUEST_ENTITY_RATING_SUCCESS });
    yield put(
      addNotificationAction({
        message: 'Your request was successfully submitted.',
        variant: 'success',
      }),
    );
  } catch (response) {
    yield put({ type: REQUEST_ENTITY_RATING_ERROR, payload: response });
    yield put(
      addNotificationAction({ message: 'Failed to submit the request.', variant: 'error' }),
    );
  }
}

export function* requestEntityRatingAndFetchData({ payload }) {
  try {
    // Sends an action that requests and entity rating
    yield put(requestEntityRatingAction(payload));
    yield take(REQUEST_ENTITY_RATING_SUCCESS);
    const { id } = payload;

    // If action above succedeed then do two another actions
    yield all([
      // Sends an action that requests Entity's documents
      // Nie powinienem wywoływać tutaj fetchEntityDocumentsSaga w jakiś sposób zamiast robić to tak jak teraz?
      put(getEntityDocumentsAction({ entityId: id })),
      // Sends an action that requests Entity's products
      // Nie powinienem wywoływać tutaj fetchEntityProductsSaga w jakiś sposób zamiast robić to tak jak teraz?
      put(getEntityProductsAction({ entityId: id })),
    ]);
    yield all([take(GET_ENTITY_DOCUMENTS_SUCCESS), take(GET_ENTITY_PRODUCTS_SUCCESS)]);

    yield put({ type: REQUEST_ENTITY_RATING_AND_FETCH_DATA_SUCCESS });
  } catch (response) {
    yield put({ type: REQUEST_ENTITY_RATING_AND_FETCH_DATA_ERROR, payload: response });
  }
}

export function* requestSigEntityRatingSaga({ payload }) {
  yield put(requestConfirmationChangedAction({ confirmed: false }));
  try {
    const { data } = yield call(requestCreditReviewRatings, payload);
    yield put({ type: REQUEST_SIG_ENTITY_RATING_SUCCESS, payload: data.itemsAdded });
    yield put(
      addNotificationAction({
        message: 'Your request was successfully submitted.',
        variant: 'success',
      }),
    );
    yield put(getCreditReviewContractDataAction);
  } catch (response) {
    const errorMessage =
      response && response.status === 402
        ? creditReviewRequestTooltips[cofaceAccessTypes.NOT_ENOUGH_CREDITS]
        : 'Failed to submit the request.';
    yield put({ type: REQUEST_SIG_ENTITY_RATING_ERROR, payload: response });
    yield put(addNotificationAction({ message: errorMessage, variant: 'error' }));
  }
}
